import Calculator from "./Calculator";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "../main.css";
import Container from "react-bootstrap/esm/Container";
// import Admin from "./Admin";

function App() {
  return (
    <div id="content">
      <BrowserRouter>
        <Container fluid="sm" id="resizeClassName">
          <Switch>
            <Route exact path="/">
              <Calculator />
            </Route>
            {/* <Route path="/admin">
              <Admin />
            </Route> */}
          </Switch>
        </Container>
      </BrowserRouter>
    </div>
  );
}

export default App;
